import { render } from "./TheLogo.vue?vue&type=template&id=3f75807f&scoped=true"
const script = {}

import "./TheLogo.vue?vue&type=style&index=0&id=3f75807f&scoped=true&lang=css"

import exportComponent from "/var/www/metiznew/www/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f75807f"]])

export default __exports__